"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LogoButton;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var style = require("./style_css.js")["default"];
function LogoButton(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var wapp = context.wapp;
  wapp.styles.use(style);
  function _onClick(e, menu) {
    if (wapp.parentWapp) {
      e.preventDefault();
      e.stopPropagation();
      var href = menu.href;
      wapp.parentWapp.client.history.push((0, _objectSpread2["default"])({
        search: "",
        hash: ""
      }, wapp.parentWapp.client.history.parsePath(href)));
    } else {
      e.stopPropagation();
    }
  }
  return /*#__PURE__*/_react["default"].createElement("a", {
    onClick: function onClick(e) {
      return _onClick(e, {
        href: wapp.parentWapp ? "/" : "https://carco.hu/"
      });
    },
    href: wapp.parentWapp ? "/" : "https://carco.hu/",
    target: wapp.parentWapp ? "_self" : "_blank",
    className: (0, _clsx["default"])(style.cursorPointer, style.textDecorationNone)
  }, props.children);
}